import { Pipe, PipeTransform } from '@angular/core';
import { format } from 'date-fns';

@Pipe({
    name: 'fnsFormat'
})

export class FnsFormatPipe implements PipeTransform {
    transform(date: Date | undefined, formatBy?: string): string {
        return date ? format(date, formatBy) : '';
    }
}
